import { render, staticRenderFns } from "./MajorSystem.vue?vue&type=template&id=034d743f&scoped=true&"
import script from "./MajorSystem.vue?vue&type=script&lang=js&"
export * from "./MajorSystem.vue?vue&type=script&lang=js&"
import style0 from "./MajorSystem.vue?vue&type=style&index=0&id=034d743f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d743f",
  null
  
)

export default component.exports